import { useEffect, useState } from 'react'
import { useBirthdayRewardConfigQuery } from './useBirthdayRewardConfigQuery'
import { useSaveBirthdayRewardConfig } from './useSaveBirthdayRewardConfig'
import type { BirthdayRewardConfig } from './useBirthdayRewardConfigQuery'

const EMPTY_CONFIG: BirthdayRewardConfig = { enabled: false, rewardItemId: null }

export function useBirthdayRewardConfig() {
  const configQuery = useBirthdayRewardConfigQuery()
  const saveMutation = useSaveBirthdayRewardConfig()

  const [enabled, setEnabled] = useState(EMPTY_CONFIG.enabled)
  const [rewardItemId, setRewardItemId] = useState<string | null>(EMPTY_CONFIG.rewardItemId)

  useEffect(() => {
    if (!configQuery.data) return
    setEnabled(configQuery.data.enabled)
    setRewardItemId(configQuery.data.rewardItemId)
  }, [configQuery.data])

  const savedConfig = configQuery.data ?? EMPTY_CONFIG
  const hasChanges = enabled !== savedConfig.enabled || rewardItemId !== savedConfig.rewardItemId
  const missingRewardItem = enabled && rewardItemId === null
  const isValid = !missingRewardItem

  function save() {
    if (!isValid) return
    saveMutation.mutate({ enabled, rewardItemId })
  }

  return {
    enabled,
    setEnabled,
    rewardItemId,
    setRewardItemId,
    hasChanges,
    missingRewardItem,
    isLoading: configQuery.isLoading,
    isError: configQuery.isError,
    onRetry: () => void configQuery.refetch(),
    isSaving: saveMutation.isPending,
    saveError: saveMutation.isError,
    save,
  }
}
